module.exports = __webpack_public_path__ + "img/folder.0d711de4.svg";